const _temp0 = require("url:../pages/react-aria/BreadcrumbsAnatomy.svg");

const _temp1 = require("url:../pages/react-aria/CalendarAnatomy.svg");

const _temp2 = require("url:../pages/react-aria/CheckboxAnatomy.svg");

const _temp3 = require("url:../pages/react-aria/CheckboxGroupAnatomy.svg");

const _temp4 = require("url:../pages/react-aria/ColorAreaAnatomy.svg");

const _temp5 = require("url:../pages/react-aria/ColorFieldAnatomy.svg");

const _temp6 = require("url:../pages/react-aria/ColorSliderAnatomy.svg");

const _temp7 = require("url:../pages/react-aria/ColorWheelAnatomy.svg");

const _temp8 = require("url:../pages/react-aria/ComboBoxAnatomy.svg");

const _temp9 = require("url:../pages/react-aria/DateFieldAnatomy.svg");

const _temp10 = require("url:../pages/react-aria/DatePickerAnatomy.svg");

const _temp11 = require("url:../pages/react-aria/DateRangePickerAnatomy2.svg");

const _temp12 = require("url:../pages/react-aria/DisclosureAnatomy.svg");

const _temp13 = require("url:../pages/react-aria/DisclosureGroupAnatomy.svg");

const _temp14 = require("url:../pages/react-aria/DndAnatomy.svg");

const _temp15 = require("url:../pages/react-aria/DndBetweenDropPosition.svg");

const _temp16 = require("url:../pages/react-aria/DndDragAffordance.svg");

const _temp17 = require("url:../pages/react-aria/DndDragPreview.svg");

const _temp18 = require("url:../pages/react-aria/DndDropOperation.svg");

const _temp19 = require("url:../pages/react-aria/DndOnDropPosition.svg");

const _temp20 = require("url:../pages/react-aria/DndRootDropPosition.svg");

const _temp21 = require("url:../pages/react-aria/GridListAnatomy.svg");

const _temp22 = require("url:../pages/react-aria/ListBoxAnatomy.svg");

const _temp23 = require("url:../pages/react-aria/MenuAnatomy.svg");

const _temp24 = require("url:../pages/react-aria/MeterAnatomy2.svg");

const _temp25 = require("url:../pages/react-aria/ModalAnatomy.svg");

const _temp26 = require("url:../pages/react-aria/NavigationTreeAnatomy.svg");

const _temp27 = require("url:../pages/react-aria/NumberFieldAnatomy.svg");

const _temp28 = require("url:../pages/react-aria/PopoverAnatomy2.svg");

const _temp29 = require("url:../pages/react-aria/PreviewTriggerAnatomy.svg");

const _temp30 = require("url:../pages/react-aria/ProgressBarAnatomy.svg");

const _temp31 = require("url:../pages/react-aria/RadioGroupAnatomy.svg");

const _temp32 = require("url:../pages/react-aria/RangeCalendarAnatomy2.svg");

const _temp33 = require("url:../pages/react-aria/SearchFieldAnatomy.svg");

const _temp34 = require("url:../pages/react-aria/SelectAnatomy.svg");

const _temp35 = require("url:../pages/react-aria/SliderAnatomy.svg");

const _temp36 = require("url:../pages/react-aria/SwitchAnatomy.svg");

const _temp37 = require("url:../pages/react-aria/TableAnatomy.svg");

const _temp38 = require("url:../pages/react-aria/TabsAnatomy.svg");

const _temp39 = require("url:../pages/react-aria/TagGroupAnatomy2.svg");

const _temp40 = require("url:../pages/react-aria/TextFieldAnatomy.svg");

const _temp41 = require("url:../pages/react-aria/TimeFieldAnatomy.svg");

const _temp42 = require("url:../pages/react-aria/ToastAnatomy.svg");

const _temp43 = require("url:../pages/react-aria/ToggleButtonGroupAnatomy2.svg");

const _temp44 = require("url:../pages/react-aria/ToolbarAnatomy.svg");

const _temp45 = require("url:../pages/react-aria/TooltipAnatomy.svg");

const _temp46 = require("url:../pages/react-aria/TreeAnatomy.svg");

const _temp47 = require("url:../pages/react-aria/assets/datepicker-rtl.png");


const _temp48 = require("url:../pages/react-aria/blog/SheetPreventDismissal.svg");

const _temp49 = require("url:../pages/react-aria/blog/SheetSnapPoints.svg");

const _temp50 = require("url:../pages/react-aria/blog/SheetStacking.svg");

const _temp51 = require("url:../pages/react-aria/blog/SheetViewport.svg");


const _temp52 = require("url:../pages/react-aria/examples/crud-dark.png");

const _temp53 = require("url:../pages/react-aria/examples/crud.png");

const _temp54 = require("url:../pages/react-aria/examples/emoji-picker-dark.png");

const _temp55 = require("url:../pages/react-aria/examples/emoji-picker.png");

const _temp56 = require("url:../pages/react-aria/examples/ios-list-dark.png");

const _temp57 = require("url:../pages/react-aria/examples/ios-list.png");

const _temp58 = require("url:../pages/react-aria/examples/kanban-dark.png");

const _temp59 = require("url:../pages/react-aria/examples/kanban.png");

const _temp60 = require("url:../pages/react-aria/examples/photos-dark.png");

const _temp61 = require("url:../pages/react-aria/examples/photos.png");

const _temp62 = require("url:../pages/react-aria/examples/ripple-button.png");

const _temp63 = require("url:../pages/react-aria/examples/swipeable-tabs-dark.png");

const _temp64 = require("url:../pages/react-aria/examples/swipeable-tabs.png");

const _temp65 = require("url:../pages/react-aria/examples/plants/plants/agapanthus.jpg");

const _temp66 = require("url:../pages/react-aria/examples/plants/plants/aloe.jpg");

const _temp67 = require("url:../pages/react-aria/examples/plants/plants/dracaena.jpg");

const _temp68 = require("url:../pages/react-aria/examples/plants/plants/fern.jpg");

const _temp69 = require("url:../pages/react-aria/examples/plants/plants/fig.jpg");

const _temp70 = require("url:../pages/react-aria/examples/plants/plants/gardenia.jpg");

const _temp71 = require("url:../pages/react-aria/examples/plants/plants/ivy.jpg");

const _temp72 = require("url:../pages/react-aria/examples/plants/plants/jacaranda.jpg");

const _temp73 = require("url:../pages/react-aria/examples/plants/plants/maidenhair.jpg");

const _temp74 = require("url:../pages/react-aria/examples/plants/plants/money.jpg");

const _temp75 = require("url:../pages/react-aria/examples/plants/plants/monstera.jpg");

const _temp76 = require("url:../pages/react-aria/examples/plants/plants/morning.jpg");

const _temp77 = require("url:../pages/react-aria/examples/plants/plants/nasturtium.jpg");

const _temp78 = require("url:../pages/react-aria/examples/plants/plants/oleander.jpg");

const _temp79 = require("url:../pages/react-aria/examples/plants/plants/poplar.jpg");

const _temp80 = require("url:../pages/react-aria/examples/plants/plants/spider.jpg");

const _temp81 = require("url:../pages/react-aria/examples/plants/plants/star.jpg");

const _temp82 = require("url:../pages/react-aria/examples/plants/plants/tree_fern.jpg");

const _temp83 = require("url:../pages/react-aria/examples/plants/plants/xmas.jpg");

const _temp84 = require("url:../pages/react-aria/examples/plants/plants/zz.jpg");




const _temp85 = require("url:../pages/react-aria/home/plants/agapanthus.jpg");

const _temp86 = require("url:../pages/react-aria/home/plants/aloe.jpg");

const _temp87 = require("url:../pages/react-aria/home/plants/dracaena.jpg");

const _temp88 = require("url:../pages/react-aria/home/plants/fern.jpg");

const _temp89 = require("url:../pages/react-aria/home/plants/fig.jpg");

const _temp90 = require("url:../pages/react-aria/home/plants/gardenia.jpg");

const _temp91 = require("url:../pages/react-aria/home/plants/ivy.jpg");

const _temp92 = require("url:../pages/react-aria/home/plants/jacaranda.jpg");

const _temp93 = require("url:../pages/react-aria/home/plants/maidenhair.jpg");

const _temp94 = require("url:../pages/react-aria/home/plants/money.jpg");

const _temp95 = require("url:../pages/react-aria/home/plants/monstera.jpg");

const _temp96 = require("url:../pages/react-aria/home/plants/morning.jpg");

const _temp97 = require("url:../pages/react-aria/home/plants/nasturtium.jpg");

const _temp98 = require("url:../pages/react-aria/home/plants/oleander.jpg");

const _temp99 = require("url:../pages/react-aria/home/plants/poplar.jpg");

const _temp100 = require("url:../pages/react-aria/home/plants/spider.jpg");

const _temp101 = require("url:../pages/react-aria/home/plants/star.jpg");

const _temp102 = require("url:../pages/react-aria/home/plants/tree_fern.jpg");

const _temp103 = require("url:../pages/react-aria/home/plants/xmas.jpg");

const _temp104 = require("url:../pages/react-aria/home/plants/zz.jpg");




const _temp105 = require("url:../pages/s2/assets/logo.svg");

const _temp106 = require("url:../pages/s2/assets/multiply.png");

const _temp107 = require("url:../pages/s2/assets/normal.png");

const _temp108 = require("url:../pages/s2/assets/preview.png");

const _temp109 = require("url:../pages/s2/assets/screen.png");


const _temp110 = require("url:../pages/s2/home/bg.svg");

const _temp111 = require("url:../pages/s2/home/app/banner.svg");




module.exports = {
  "react-aria":   {
    "BreadcrumbsAnatomy":     {
      "svg": _temp0
    },
    "CalendarAnatomy":     {
      "svg": _temp1
    },
    "CheckboxAnatomy":     {
      "svg": _temp2
    },
    "CheckboxGroupAnatomy":     {
      "svg": _temp3
    },
    "ColorAreaAnatomy":     {
      "svg": _temp4
    },
    "ColorFieldAnatomy":     {
      "svg": _temp5
    },
    "ColorSliderAnatomy":     {
      "svg": _temp6
    },
    "ColorWheelAnatomy":     {
      "svg": _temp7
    },
    "ComboBoxAnatomy":     {
      "svg": _temp8
    },
    "DateFieldAnatomy":     {
      "svg": _temp9
    },
    "DatePickerAnatomy":     {
      "svg": _temp10
    },
    "DateRangePickerAnatomy2":     {
      "svg": _temp11
    },
    "DisclosureAnatomy":     {
      "svg": _temp12
    },
    "DisclosureGroupAnatomy":     {
      "svg": _temp13
    },
    "DndAnatomy":     {
      "svg": _temp14
    },
    "DndBetweenDropPosition":     {
      "svg": _temp15
    },
    "DndDragAffordance":     {
      "svg": _temp16
    },
    "DndDragPreview":     {
      "svg": _temp17
    },
    "DndDropOperation":     {
      "svg": _temp18
    },
    "DndOnDropPosition":     {
      "svg": _temp19
    },
    "DndRootDropPosition":     {
      "svg": _temp20
    },
    "GridListAnatomy":     {
      "svg": _temp21
    },
    "ListBoxAnatomy":     {
      "svg": _temp22
    },
    "MenuAnatomy":     {
      "svg": _temp23
    },
    "MeterAnatomy2":     {
      "svg": _temp24
    },
    "ModalAnatomy":     {
      "svg": _temp25
    },
    "NavigationTreeAnatomy":     {
      "svg": _temp26
    },
    "NumberFieldAnatomy":     {
      "svg": _temp27
    },
    "PopoverAnatomy2":     {
      "svg": _temp28
    },
    "PreviewTriggerAnatomy":     {
      "svg": _temp29
    },
    "ProgressBarAnatomy":     {
      "svg": _temp30
    },
    "RadioGroupAnatomy":     {
      "svg": _temp31
    },
    "RangeCalendarAnatomy2":     {
      "svg": _temp32
    },
    "SearchFieldAnatomy":     {
      "svg": _temp33
    },
    "SelectAnatomy":     {
      "svg": _temp34
    },
    "SliderAnatomy":     {
      "svg": _temp35
    },
    "SwitchAnatomy":     {
      "svg": _temp36
    },
    "TableAnatomy":     {
      "svg": _temp37
    },
    "TabsAnatomy":     {
      "svg": _temp38
    },
    "TagGroupAnatomy2":     {
      "svg": _temp39
    },
    "TextFieldAnatomy":     {
      "svg": _temp40
    },
    "TimeFieldAnatomy":     {
      "svg": _temp41
    },
    "ToastAnatomy":     {
      "svg": _temp42
    },
    "ToggleButtonGroupAnatomy2":     {
      "svg": _temp43
    },
    "ToolbarAnatomy":     {
      "svg": _temp44
    },
    "TooltipAnatomy":     {
      "svg": _temp45
    },
    "TreeAnatomy":     {
      "svg": _temp46
    },
    "assets":     {
      "datepicker-rtl":       {
        "png": _temp47
      }
    },
    "blog":     {
      "SheetPreventDismissal":       {
        "svg": _temp48
      },
      "SheetSnapPoints":       {
        "svg": _temp49
      },
      "SheetStacking":       {
        "svg": _temp50
      },
      "SheetViewport":       {
        "svg": _temp51
      }
    },
    "examples":     {
      "crud-dark":       {
        "png": _temp52
      },
      "crud":       {
        "png": _temp53
      },
      "emoji-picker-dark":       {
        "png": _temp54
      },
      "emoji-picker":       {
        "png": _temp55
      },
      "ios-list-dark":       {
        "png": _temp56
      },
      "ios-list":       {
        "png": _temp57
      },
      "kanban-dark":       {
        "png": _temp58
      },
      "kanban":       {
        "png": _temp59
      },
      "photos-dark":       {
        "png": _temp60
      },
      "photos":       {
        "png": _temp61
      },
      "ripple-button":       {
        "png": _temp62
      },
      "swipeable-tabs-dark":       {
        "png": _temp63
      },
      "swipeable-tabs":       {
        "png": _temp64
      },
      "plants":       {
        "plants":         {
          "agapanthus":           {
            "jpg": _temp65
          },
          "aloe":           {
            "jpg": _temp66
          },
          "dracaena":           {
            "jpg": _temp67
          },
          "fern":           {
            "jpg": _temp68
          },
          "fig":           {
            "jpg": _temp69
          },
          "gardenia":           {
            "jpg": _temp70
          },
          "ivy":           {
            "jpg": _temp71
          },
          "jacaranda":           {
            "jpg": _temp72
          },
          "maidenhair":           {
            "jpg": _temp73
          },
          "money":           {
            "jpg": _temp74
          },
          "monstera":           {
            "jpg": _temp75
          },
          "morning":           {
            "jpg": _temp76
          },
          "nasturtium":           {
            "jpg": _temp77
          },
          "oleander":           {
            "jpg": _temp78
          },
          "poplar":           {
            "jpg": _temp79
          },
          "spider":           {
            "jpg": _temp80
          },
          "star":           {
            "jpg": _temp81
          },
          "tree_fern":           {
            "jpg": _temp82
          },
          "xmas":           {
            "jpg": _temp83
          },
          "zz":           {
            "jpg": _temp84
          }
        }
      }
    },
    "home":     {
      "plants":       {
        "agapanthus":         {
          "jpg": _temp85
        },
        "aloe":         {
          "jpg": _temp86
        },
        "dracaena":         {
          "jpg": _temp87
        },
        "fern":         {
          "jpg": _temp88
        },
        "fig":         {
          "jpg": _temp89
        },
        "gardenia":         {
          "jpg": _temp90
        },
        "ivy":         {
          "jpg": _temp91
        },
        "jacaranda":         {
          "jpg": _temp92
        },
        "maidenhair":         {
          "jpg": _temp93
        },
        "money":         {
          "jpg": _temp94
        },
        "monstera":         {
          "jpg": _temp95
        },
        "morning":         {
          "jpg": _temp96
        },
        "nasturtium":         {
          "jpg": _temp97
        },
        "oleander":         {
          "jpg": _temp98
        },
        "poplar":         {
          "jpg": _temp99
        },
        "spider":         {
          "jpg": _temp100
        },
        "star":         {
          "jpg": _temp101
        },
        "tree_fern":         {
          "jpg": _temp102
        },
        "xmas":         {
          "jpg": _temp103
        },
        "zz":         {
          "jpg": _temp104
        }
      }
    }
  },
  "s2":   {
    "assets":     {
      "logo":       {
        "svg": _temp105
      },
      "multiply":       {
        "png": _temp106
      },
      "normal":       {
        "png": _temp107
      },
      "preview":       {
        "png": _temp108
      },
      "screen":       {
        "png": _temp109
      }
    },
    "home":     {
      "bg":       {
        "svg": _temp110
      },
      "app":       {
        "banner":         {
          "svg": _temp111
        }
      }
    }
  }
}